import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    num: "01",
    month: "Month One",
    title: "Fear",
    subtitle: "Returning to Love",
    quote: "What is the root of your fear?",
    body: "We identify where fear originates, how it manifests in the body, and what it truly needs in order to soften. Through guided somatic and reflective practices, you begin a process of awareness, detoxification, purification, and emotional regulation, releasing old patterns, conditioning, and stories that no longer serve you. This month is about moving from contraction into compassion, and from fear into love.",
  },
  {
    num: "02",
    month: "Month Two",
    title: "Safety",
    subtitle: "From Stress to Safety",
    quote: "The body is an instrument.",
    body: "We focus on nervous system regulation, understanding how your body responds to stress and learning what genuine safety feels like. We explore the autonomic nervous system, tension patterns, and stored emotional responses while gradually expanding your window of tolerance. This month is about teaching the body that it is safe to be present, grounded, and secure in your process of awakening.",
  },
  {
    num: "03",
    month: "Month Three",
    title: "Identity & Direction",
    subtitle: "Becoming Who You Are",
    quote: "Who are you becoming?",
    body: "From a clearer and more regulated space, we begin to nourish the parts of you that are ready to emerge. This month invites creative flow, visioning, grounding, and the anchoring of a new foundation. You will reconnect with your authentic self and cultivate a deeper sense of purpose, inspiration, and aligned direction, embodying the person your awakening is calling you to become.",
  },
];

export const Journey = () => (
  <section
    id="journey"
    data-testid="journey-section"
    className="bg-mist px-6 md:px-12 py-28 md:py-40 lg:py-48"
  >
    <div className="max-w-6xl mx-auto">
      <Reveal>
        <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-amethyst font-medium mb-6">
          The 3-Month Journey
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight leading-none text-soil max-w-3xl">
          Three chapters. <span className="italic text-amethyst">One unfolding.</span>
        </h2>
      </Reveal>

      <div className="mt-20 md:mt-32 space-y-24 md:space-y-36">
        {CHAPTERS.map((c, i) => (
          <div
            key={c.num}
            data-testid={`journey-chapter-${i + 1}`}
            className={`grid md:grid-cols-12 gap-8 md:gap-12 items-start ${
              i % 2 === 1 ? "" : ""
            }`}
          >
            <Reveal
              className={`md:col-span-4 ${i % 2 === 1 ? "md:order-2 md:col-start-9" : ""}`}
              y={30}
            >
              <span className="font-serif text-outline-gold text-[26vw] md:text-[11vw] leading-none block select-none">
                {c.num}
              </span>
            </Reveal>
            <div
              className={`md:col-span-7 ${
                i % 2 === 1 ? "md:order-1 md:col-start-1" : "md:col-start-6"
              }`}
            >
              <Reveal delay={0.1}>
                <p className="text-xs uppercase tracking-[0.25em] text-clay mb-4">
                  {c.month}
                </p>
                <h3 className="font-serif text-3xl md:text-4xl lg:text-5xl text-soil tracking-tight">
                  {c.title}
                  <span className="block italic text-amethyst text-2xl md:text-3xl lg:text-4xl mt-3">
                    {c.subtitle}
                  </span>
                </h3>
                <p className="font-serif italic text-xl md:text-2xl text-gold mt-6">
                  “{c.quote}”
                </p>
                <p className="text-base md:text-lg text-clay leading-relaxed mt-6 max-w-2xl">
                  {c.body}
                </p>
              </Reveal>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
